<template>
  <div class="search-item" :style="{width:searchWidth}">
    <label class="search-label">{{searchLabel}}</label>
    <el-date-picker v-model="value" :type="searchDateType" placeholder="选择日期时间" style="width: 100%;" value-format="yyyy-MM-dd">
    </el-date-picker>
  </div>
</template>
<script>
  export default {
    name: "searchInput",
    props: {
      searchDateType: {
        type: String,
        default: ''
      },
      searchLabel: {
        type: String,
        default: ''
      },
      searchWidth: {
        type: String,
        default: ''
      },
      searchValue: {
        type: String,
        default: ''
      },
    },
    data: function() {
      return {
        value: this.searchValue
      }
    },
    /* computed: {
    }, */
    methods: {}
  };
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/list/search/searchDate.vue